/* Keep the individual sheet gifts one-time, including carts saved before the offer changed. */
(function () {
  if (window.CadianSheetGifts) return;
  var seedEl = document.querySelector('[data-cadian-sheet-cart]'), seed;
  try { seed = JSON.parse(seedEl.textContent); } catch (e) { return; }
  var giftIds = (seed.giftVariantIds || []).map(Number).filter(function (id, i, ids) { return id > 0 && ids.indexOf(id) === i; });
  var pending = null, blocked = false;
  var mutationSelector = '[data-qty-inc], [data-qty-dec], [data-line-remove], [data-mode-one], [data-mode-sub], [data-upsell-add], [data-cad-discount-apply], [data-cad-discount-remove], [data-cad-discount-input], cart-remove-button a, input[name="updates[]"]';
  var checkoutSelector = '[name="checkout"], [data-checkout], #checkout, #nvd-with-checkout-btn, #nvd-without-checkout-btn, .additional-checkout-buttons, shopify-accelerated-checkout-cart, a[href="/checkout"]';
  function url(action) {
    return (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart' + (action ? '/' + action : '') + '.js';
  }
  function request(action, body) {
    var options = { headers: { 'Accept': 'application/json' } };
    if (body) {
      body.sections = ['cart-drawer', 'cart-icon-bubble'];
      body.sections_url = window.location.pathname;
      options.method = 'POST'; options.headers['Content-Type'] = 'application/json'; options.body = JSON.stringify(body);
    }
    return fetch(url(action), options).then(function (response) {
      return response.json().then(function (cart) {
        if (!response.ok || (cart.status && cart.status >= 400)) throw new Error(cart.description || cart.message || 'Unable to update your gifts.');
        return cart;
      });
    });
  }
  function lock(value) {
    document.querySelectorAll('.additional-checkout-buttons, shopify-accelerated-checkout-cart').forEach(function (wallets) { wallets.inert = value || blocked; });
    document.querySelectorAll(checkoutSelector + ", " + mutationSelector).forEach(function (button) {
      if (value && !button.disabled) { button.setAttribute('data-gift-locked', ''); button.disabled = true; }
      else if (!value && button.hasAttribute('data-gift-locked')) { button.disabled = false; button.removeAttribute('data-gift-locked'); }
    });
  }
  function message(text) {
    var alert = document.querySelector('[data-sheet-gift-error]');
    if (!alert && text) {
      alert = document.createElement('div'); alert.className = 'cad-cart-error'; alert.setAttribute('data-sheet-gift-error', ''); alert.setAttribute('role', 'alert');
      var target = document.querySelector('#cart-errors') || document.querySelector('.cad-dw__foot');
      if (!target) return;
      target.prepend(alert);
    }
    if (!alert) return;
    alert.textContent = text || ''; alert.hidden = !text;
    if (text && !pending) {
      var retry = document.createElement('button'); retry.type = 'button'; retry.textContent = 'Retry gift update'; retry.setAttribute('data-retry-sheet-gifts', ''); alert.appendChild(retry);
    }
  }
  function plan(cart) {
    var items = cart.items || [];
    var hasSheet = items.some(function (line) { return (Number(seed.sheetProductId) > 0 && Number(line.product_id) === Number(seed.sheetProductId)) || line.handle === 'grounding-sleep-sheets'; });
    var gifts = items.filter(function (line) { return line.properties && line.properties._cadian_gift; });
    if (hasSheet && gifts.length && giftIds.length !== Number(seed.expectedGiftCount || 2)) throw new Error('The gifts are temporarily unavailable.');
    var updates = {}, retained = {}, replace = {};
    gifts.forEach(function (line) {
      var id = Number(line.variant_id), eligible = giftIds.indexOf(id) !== -1;
      if (hasSheet && eligible && !line.selling_plan_allocation && !retained[id]) {
        retained[id] = true; if (line.quantity !== 1) updates[line.key] = 1;
      } else {
        updates[line.key] = 0;
        if (hasSheet && eligible && line.selling_plan_allocation) replace[id] = true;
      }
    });
    // Upgrade saved sheet carts too. An existing one-time tester already qualifies,
    // so leave its quantity intact and let Shopify discount one unit.
    var testerId = Number(seed.testerVariantId);
    if (hasSheet && testerId && seed.testerAvailable && !items.some(function (line) {
      return Number(line.variant_id) === testerId && !line.selling_plan_allocation;
    })) replace[testerId] = true;
    return { updates: updates, add: giftIds.filter(function (id) { return replace[id] && !retained[id]; }).map(function (id) {
      return { id: id, quantity: 1, properties: { _cadian_gift: 'true' } };
    }) };
  }

  function render(cart) {
    if (typeof window.cadianRefreshCart === 'function') window.cadianRefreshCart(cart);
    if (/\/cart\/?$/.test(window.location.pathname)) window.location.reload();
  }
  function normalize(cart) {
    if (pending) return pending;
    var next;
    try { next = plan(cart); } catch (error) { blocked = true; lock(false); return Promise.reject(error); }
    if (!Object.keys(next.updates).length && !next.add.length) { blocked = false; message(''); lock(false); return Promise.resolve(cart); }
    blocked = true; lock(true);
    // Add the replacement first so a failed request never leaves the customer without gifts.
    pending = (next.add.length ? request('add', { items: next.add }).then(function () {
      return request('');
    }) : Promise.resolve(cart)).then(function (updated) {
      var remaining = plan(updated);
      return Object.keys(remaining.updates).length ? request('update', { updates: remaining.updates }) : updated;
    }).then(function (updated) {
      blocked = false; message(''); render(updated); return updated;
    }).catch(function (error) {
      blocked = true;
      throw error;
    }).finally(function () { pending = null; lock(false); });
    return pending;
  }
  function retry() {
    if (pending) return;
    request('').then(function (cart) { return normalize(cart).then(function (updated) { if (updated === cart) render(updated); }); }).catch(function () { message('We could not update your gifts. Please retry before checkout. '); });
  }
  window.CadianSheetGifts = { normalize: normalize };
  document.addEventListener('click', function (event) {
    if (pending && event.target.closest(mutationSelector)) { event.preventDefault(); event.stopImmediatePropagation(); return; }
    if (event.target.closest('[data-retry-sheet-gifts]')) { event.preventDefault(); retry(); return; }
    if (event.target.closest(checkoutSelector) && (pending || blocked || document.querySelector('[data-legacy-sheet-gift]'))) {
      event.preventDefault(); event.stopImmediatePropagation();
      message(pending ? 'Updating your gifts. Please wait a moment.' : 'Please update your gifts before checkout. ');
    }
  }, true);
  document.addEventListener('submit', function (event) {
    if ((event.target.id === 'cart' || event.target.id === 'CartDrawer-Form' || event.target.matches('[data-cad-discount-form]')) && (pending || blocked || document.querySelector('[data-legacy-sheet-gift]'))) {
      event.preventDefault(); event.stopImmediatePropagation();
      message(pending ? 'Updating your gifts. Please wait a moment.' : 'Please update your gifts before checkout. ');
    }
  }, true);
  function start() {
    normalize(seed).catch(function () { message('We could not update your gifts. Please retry before checkout. '); });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event.cartData && typeof event.cartData.total_price === 'number') normalize(event.cartData).catch(function () { message('We could not update your gifts. Please retry before checkout. '); });
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
